import { render, staticRenderFns } from "./activity-center-container.vue?vue&type=template&id=6a33bd7e"
import script from "./activity-center-container.vue?vue&type=script&lang=js"
export * from "./activity-center-container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports